@if (!stackLabel) {
  <label
    class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer"
    for="{{ switchIndex }}"
  >
    @if (labelPosition === 'left') {
      <span class="tw-mr-3 tw-font-light tw-text-gray-700">{{ label }} </span>
    }
    <input
      [attr.id]="switchIndex"
      type="checkbox"
      [formControlName]="controlName"
      class="tw-sr-only tw-peer"
    />
    <div
      class="{{
        props.label
      }} tw-w-11 tw-h-6 tw-bg-gray-200 peer-focus:tw-outline-none peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 dark:peer-focus:tw-ring-blue-800 tw-rounded-full tw-peer dark:tw-bg-gray-700 peer-checked:after:tw-translate-x-full rtl:peer-checked:after:-tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-[2px] {{
        labelPosition === 'right' ? 'after:tw-start-[2px]' : ''
      }} after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:tw-w-5 after:tw-h-5 after:tw-transition-all dark:tw-border-gray-600 peer-checked:tw-bg-blue-600"
    ></div>
    @if (labelPosition === 'right') {
      <span
        class="ms-3 tw-text-sm font-medium tw-text-gray-900 dark:tw-text-gray-300"
        >{{ label }}
      </span>
    }
  </label>
  <div class="tw-text-sm">{{ helperText }}</div>
} @else {
  <div class="tw-mr-3 tw-font-light tw-text-gray-700">{{ label }}</div>
  <label
    class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer"
    for="{{ switchIndex }}"
  >
    <input
      [attr.id]="switchIndex"
      type="checkbox"
      [formControlName]="controlName"
      class="tw-sr-only tw-peer"
    />
    <div
      class="{{
        props.label
      }} tw-w-11 tw-h-6 tw-bg-gray-200 peer-focus:tw-outline-none peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 dark:peer-focus:tw-ring-blue-800 tw-rounded-full tw-peer dark:tw-bg-gray-700 peer-checked:after:tw-translate-x-full rtl:peer-checked:after:-tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-[2px] {{
        labelPosition === 'right' ? 'after:tw-start-[2px]' : ''
      }} after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:w-5 after:tw-h-5 after:tw-transition-all dark:tw-border-gray-600 peer-checked:tw-bg-blue-600"
    ></div>
  </label>
  <div class="tw-text-sm">{{ helperText }}</div>
}
